<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>

    <div mat-dialog-content class="dialog-content text-muted">
        {{ data.content }}

        <!-- Material Dropdown -->
        <mat-form-field appearance="outline" class="w-100 mt-3">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="status" name="status">
                <mat-option *ngFor="let status of statusList" [value]="status.value">
                    {{ status.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">
            {{ data.cancelText }}
        </button>

        <button mat-button class="btn btn-success yes-button" (click)="save()" *ngIf="!isLoading; else loadingTemplate"
            cdkFocusInitial>
            {{ data.confirmText }}
        </button>

        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>